import { onMounted, watch } from 'vue';

export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return;

  const GA_ID = 'G-2ZBBZ0L7SC';

  const addScript = (src: string, id?: string): void => {
    if (id && document.getElementById(id)) return;
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.defer = true;
    if (id) script.id = id;
    document.head.appendChild(script);
  };

  const initGtag = (anonymize: boolean) => {
    if (!(window as any).dataLayer) {
      (window as any).dataLayer = [];
    }

    const gtag = (...args: any[]): void => (window as any).dataLayer.push(args);

    (window as any).gtag = gtag;

    gtag('js', new Date());
    gtag('config', GA_ID, {
      anonymize_ip: anonymize,
    });
  };

  const {
    cookiesEnabledIds,
    isConsentGiven,
  } = useCookieControl();

  const handleConsentScripts = (anonymizeInitially = true): void => {
    addScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`, 'ga-script');
    initGtag(anonymizeInitially);
  };

  const updateGtagConfig = (anonymize: boolean): void => {
    if (typeof (window as any).gtag === 'function') {
      (window as any).gtag('config', GA_ID, {
        anonymize_ip: anonymize,
      });
    }
  };

  watch(
    () => cookiesEnabledIds.value,
    (newVal, oldVal) => {
      const previouslyAccepted = oldVal?.includes('performance_cookies') ?? false;
      const nowAccepted = newVal?.includes('performance_cookies') ?? false;

      if (!previouslyAccepted && nowAccepted) {
        if (!document.getElementById('ga-script')) {
          handleConsentScripts(false); // full tracking
        } else {
          updateGtagConfig(false);
        }
      }
    },
    { immediate: true }
  );

  const consented = isConsentGiven.value && cookiesEnabledIds.value?.includes('performance_cookies');
  handleConsentScripts(!consented); // anonymize IP until consent
});
